import * as React from 'react';
import { motion } from 'framer-motion';
import Button from '../../Shared/Button';
import event1 from '../../../assets/cha.png';
import event2 from '../../../assets/prendas.jpeg';
import event3 from '../../../assets/massage.png';

const Events: React.FC = () => {
  const thumbImages: string[] = [
    event1,
    event2,
    event3,
  ];


  // Animation variants for the section content (stagger within)
  const sectionVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2,
      },
    },
  };

  // Animation variants for individual elements
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.1, ease: 'easeOut' } },
  };

  const imageVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.3, ease: 'easeInOut' } },
  };

  return (
    <motion.section
      id="experiencias"
      className="py-24 bg-zinc-200 overflow-hidden" // Added overflow-hidden for safety
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={sectionVariants}
    >
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-12 lg:gap-16">
          {/* Left Column: Text and Thumbnails */}
          <div className='flex flex-col xl:flex-row items-center justify-center gap-8'>
            <motion.div
              className="flex flex-col lg:flex-row justify-center lg:text-left"
              variants={sectionVariants} // Apply stagger to this column's children
            >
              {/* New wrapper div for text content */}

              <motion.div
                className="flex flex-col items-center text-center mb-8" // Center content and add bottom margin
                variants={itemVariants} // Animate this block as one item
              >
                <motion.h2
                  className="text-4xl lg:text-5xl text-dark mb-4" // Removed text-center
                // variants={itemVariants} // Variant moved to parent
                >
                  Eventos
                </motion.h2>
                <motion.p
                  className="text-lg lg:text-xl text-textDark mb-8 max-w-xs lg:max-w-none"
                // variants={itemVariants} // Variant moved to parent
                >
                  Mais do que um cabeleireiro somos uma experiência
                </motion.p>
                <motion.div // variants={itemVariants} // Variant moved to parent
                // className="mb-10" // Margin moved to parent wrapper
                >
                  <Button onClick={() => window.open('https://www.instagram.com/schiquebeautylounge/', '_blank')} className="mt-4 bg-bordeux text-white rounded-full hover:bg-bordeuxDark hover:scale-105 transition-all duration-300 ease-in-out">
                    Saber mais
                  </Button>
                </motion.div>
              </motion.div>


            </motion.div>

            {/* Thumbnail Grid */}
            <motion.div
              className="grid md:grid-cols-3 max-w-72 md:max-w-none gap-8 xl:gap-3 xl:grid-cols-1 xl:max-w-[200px]"
              variants={sectionVariants} // Apply stagger to thumbnails
            >
              {thumbImages.map((thumb, index) => (
                <motion.div
                  key={index}
                  className="bg-white p-2 pb-10 shadow-md cursor-pointer"
                  variants={imageVariants} // Animate each thumbnail wrapper
                  whileHover={{ scale: 1.05 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  <img
                    src={thumb}
                    alt={`Event thumbnail ${index + 1}`}
                    className="w-full aspect-square object-cover "
                  />
                </motion.div>
              ))}
            </motion.div>

          </div>
          {/* Right Column: Main Image */}
          <div className='hidden xl:flex h-full justify-center items-center '>
            <motion.div
              className="p-6 pb-20 shadow-md cursor-pointer bg-white h-full w-2/3 xl:w-full"
              variants={imageVariants} // Animate each thumbnail wrapper
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <img
                src={event1}
                alt={`Event thumbnail`}
                className="w-full h-full object-cover "
              />
            </motion.div>
          </div>
        </div>
      </div>
    </motion.section >
  );
};

export default Events; 